import { memo, useMemo } from "react";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { ArticleListItem } from "./article-item";
import { useNewsReadState, useSupportAnnouncements } from "./hooks";

export type { SupportAnnouncement } from "./hooks";

type Props = {
	hotelID: string;
};

export const IslandAdminMediaArticleList = memo(({ hotelID }: Props) => {
	// support サイトから実行時に取得する。取得前・取得失敗時は undefined。
	const announcements = useSupportAnnouncements();

	const announcementHrefs = useMemo(() => announcements?.map(({ href }) => href), [announcements]);
	const { isRead, markAsRead } = useNewsReadState(announcementHrefs);

	if (!announcements?.length) {
		return null;
	}

	return (
		<FeatureIslandMainWithBackGround>
			<div>
				<h3 className="text-lg font-semibold">ニュース</h3>
			</div>

			<div className="flex max-w-full gap-x-8 overflow-x-scroll px-4 py-10">
				{announcements.map((announcement) => (
					<ArticleListItem
						key={announcement.href}
						hotelID={hotelID}
						announcement={announcement}
						isRead={isRead}
						markAsRead={markAsRead}
					/>
				))}
			</div>
		</FeatureIslandMainWithBackGround>
	);
});
